import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.widget.modal.cage.env');
import { OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, HostListener, ChangeDetectorRef } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'wiz-portal-farm-widget-modal-cage-env',
template: templateSource || '',
    styles: [``],
})
export class PortalFarmWidgetModalCageEnvComponent implements OnInit, OnChanges {

    @Input() data: any;
    @Output() closed = new EventEmitter<any>();

    public form: any = {};
    public closing = false;

    constructor(@Inject( ChangeDetectorRef) private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.initialize();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            this.initialize();
        }
    }

    @HostListener('document:keydown.escape')
    onEscKey() {
        if (!this.closing) this.cancel();
    }

    private initialize() {
        const today = moment().format('YYYY-MM-DD');

        const defaults = {
            date: today,
            temp: 0,
            humidity: 0,
            co2: 0,
            ammonia: 0,
            lux: 0,
            fan: "작동"
        };

        let data = { ...(this.data || {}) };

        if (data.date) {
            data.date = moment(data.date).format('YYYY-MM-DD');
        }

        this.form = {
            ...defaults,
            ...data
        };
    }

    private closeWithAnimation(value: any) {
        if (this.closing) return;
        this.closing = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.closed.emit(value);
        }, 150);
    }

    public register() {
        let result = { ...this.form };
        result.date = moment(result.date).format('YYYY-MM-DD');
        this.closeWithAnimation(result);
    }

    public cancel() {
        this.closeWithAnimation(null);
    }
}

export default PortalFarmWidgetModalCageEnvComponent;